import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";

import Navbar from "@/components/xvpr/Navbar";
import Hero from "@/components/xvpr/Hero";
import Marquee from "@/components/xvpr/Marquee";
import PresaleSection from "@/components/xvpr/PresaleSection";
import AboutSection from "@/components/xvpr/AboutSection";
import SpecsSection from "@/components/xvpr/SpecsSection";
import FixedSupplySection from "@/components/xvpr/FixedSupplySection";
import TokenomicsSection from "@/components/xvpr/TokenomicsSection";
import UtilitySection from "@/components/xvpr/UtilitySection";
import EcosystemSection from "@/components/xvpr/EcosystemSection";
import SecuritySection from "@/components/xvpr/SecuritySection";
import GovernanceSection from "@/components/xvpr/GovernanceSection";
import RoadmapSection from "@/components/xvpr/RoadmapSection";
import WhitepaperSection from "@/components/xvpr/WhitepaperSection";
import FaqSection from "@/components/xvpr/FaqSection";
import FinalCta from "@/components/xvpr/FinalCta";
import Footer from "@/components/xvpr/Footer";

function App() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App relative min-h-screen bg-[#030305] text-white antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <PresaleSection />
        <AboutSection />
        <SpecsSection />
        <FixedSupplySection />
        <TokenomicsSection />
        <UtilitySection />
        <EcosystemSection />
        <SecuritySection />
        <GovernanceSection />
        <RoadmapSection />
        <WhitepaperSection />
        <FaqSection />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}

export default App;
